const size = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop: 2560
};

export const device = {
    mobileS: `(min-width: ${size.mobileS}px)`,
    mobileM: `(min-width: ${size.mobileM}px)`,
    mobileL: `(min-width: ${size.mobileL}px)`,
    tablet: `(min-width: ${size.tablet}px)`,
    laptop: `(min-width: ${size.laptop}px)`,
    laptopL: `(min-width: ${size.laptopL}px)`,
    desktop: `(min-width: ${size.desktop}px)`,
    desktopL: `(min-width: ${size.desktop}px)`
};

// background: #02BF89;


const theme = {
    // blue: `#00A19A`,
    blue: `#02BF89`,
    lightblue: `#F4F9FC`,
    halfblue: `#E3ECF4`,
    red: `#EF4058`,
    grey: `#868484`,
    // green: `#3FC664`,
    green: `#02BF89`,
    // nice_green: `#25E480`,
    nice_green: `#02BF89`,
    yellow: `#F5C451`,

    background: {
        primary: `#FFFFFF`,
        secondary: `#F5F5F5`,
        support: `#EFEFEF`
    },

    text: {
        primary: `#212121`,
        secondary: `#B5B5B5`,
        light: `#BCBEBE`
    },

    shadow: {
        small: `box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.15);`
    },

    size,
    device
};

const theme2 = {
    // blue: `#0077B6`,         // A vibrant medium blue
    blue: `#02BF89`,         // A vibrant medium blue
    lightblue: `#ADD8E6`,    // A soft, light blue
    halfblue: `#7FB3D5`,     // A muted, medium-light blue
    red: `#EF4058`,          // Keeping the original red for contrast
    grey: `#A9A9A9`,         // A neutral grey
    // green: `#2E8B57`,        // A green with a hint of blue
    green: `#02BF89`,        // A green with a hint of blue
    // nice_green: `#3FC664`,   // Keeping the original nice green
    nice_green: `#02BF89`,   // Keeping the original nice green
    yellow: `#F5C451`,       // Keeping the original yellow

    background: {
        primary: `#F0F8FF`,  // A very light blue, almost white
        secondary: `#E6E6FA`,// A light lavender, adding a hint of purple
        support: `#D8E2EC`,  // A light grey with a blue tint
    },

    text: {
        primary: `#212121`,  // Keeping the original primary text color for readability
        secondary: `#4F4F4F`,// A darker grey for secondary text
        light: `#707070`,    // A lighter grey for less emphasized text
    },

    shadow: {
        small: `box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.1);`, // Slightly lighter shadow
    },

    size,
    device,
};


const realTheme = (window.location.href.indexOf("bl000") > -1) ? theme2 : theme;

export default realTheme;
